import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m16 4.525 5.037-1.95c.361-.144.696-.104 1.003.122.307.226.46.53.46.907V18.77c0 .235-.067.443-.202.624-.135.18-.321.316-.557.406L16 21.75l-6.5-2.275-5.037 1.95c-.361.144-.696.104-1.003-.121a1.07 1.07 0 0 1-.46-.909V5.23c0-.234.068-.442.204-.623.136-.18.32-.316.555-.406L9.5 2.25 16 4.525ZM10.583 17.58l4.334 1.517V6.42l-4.334-1.517V17.58Z"
	})
});
export default SvgMap;
